import {
  ThumbnailRepresentation,
  ThumbnailService,
} from "features/gallery/service/thumbnail.service"
import { GalleryService } from "features/gallery/service/gallery.service"
import { buildThumbnailRepresentation } from "features/gallery/service/thumbnail.functions"

/**
 * This service is responsible for managing the state of the thumbnails.
 * Is based on the ThumbnailService, but adds the functionality to support featured images.
 * When a featured image is set, the thumbnail representation is updated.
 * Overrides the buildThumbnailRepresentation with "_buildEventHighlightsThumbnailRepresentation"
 *  function to add the featured image functionality.
 *
 */
export class EventHighlightThumbnailService extends ThumbnailService {
  constructor(galleryService: GalleryService) {
    super(galleryService, buildThumbnailRepresentation(galleryService))
    this.buildThumbnailRepresentation =
      this._buildEventHighlightsThumbnailRepresentation.bind(this)
  }

  /**
   * If user has no edit rights, the top-right action is removed.
   * Else either the button for setting the featured image or the display of the filled-star is added to the top-right action.
   */
  private _buildEventHighlightsThumbnailRepresentation(
    thumbnailRepresentation: ThumbnailRepresentation,
    canEdit: boolean
  ): ThumbnailRepresentation {
    if (canEdit) {
      return buildThumbnailRepresentation(this.galleryService)(
        thumbnailRepresentation,
        canEdit
      )
    } else {
      const updatedThumbnailRepresentation = buildThumbnailRepresentation(
        this.galleryService
      )(thumbnailRepresentation, canEdit)
      updatedThumbnailRepresentation.topRightAction.value = null
      return updatedThumbnailRepresentation
    }
  }
}
